import { selectDeviceSizeIsMobile } from '../../state/reducers/deviceSlice'
import { useSelector } from 'react-redux'

export const useInputSizeProps = () => {
  const isMobile = useSelector(selectDeviceSizeIsMobile)

  return { size: isMobile ? 'large' : 'medium' }
}
